// Modalul «Индикаторы» — comutatoarele care se salvează în `sx_indicators`.

import { el, clear, debounce } from '../core/util.js';
import { modal, toggle } from './components.js';
import { settings } from '../core/state.js';

const GROUPS = [
  {
    title: 'ДАННЫЕ',
    items: [{
      id: 'techdata',
      name: 'Технические данные по монете',
      hint: 'Объём, волатильность, корреляция, изменение цены за выбранный период времени '
          + '(от 5 минут до 24 часов)',
    }],
  },
  {
    title: 'ИНДИКАТОРЫ',
    items: [
      {
        id: 'oichart', name: 'Открытый интерес',
        hint: 'Сколько денег стоит в открытых позициях по монете. Отдельной панелью под свечами: '
            + 'растёт вместе с ценой — в рынок заходят новые деньги, падает — позиции закрывают',
      },
      { id: 'rsi', name: 'Индекс относительной силы (RSI)', hint: 'RSI определяет силу тренда и вероятность его разворота' },
      {
        id: 'macd', name: 'Схождение-расхождение скользящих (MACD)',
        hint: 'Показывает смену импульса: пересечение линии MACD с сигнальной и гистограмма расхождения',
      },
      {
        id: 'sma', name: 'Простая скользящая средняя (SMA)',
        hint: 'Скользящая средняя, показывающая среднюю цену за выбранный период для сглаживания колебаний',
      },
      {
        id: 'ema', name: 'Экспоненциальная скользящая средняя (EMA)',
        hint: 'EMA сильнее реагирует на последние изменения цены, помогая отслеживать тренд',
      },
      {
        id: 'bb', name: 'Полосы Боллинджера',
        hint: 'Индикатор волатильности рынка, показывающий зоны перекупленности и перепроданности',
      },
      {
        id: 'ao', name: 'Awesome Oscillator (AO)',
        hint: 'Индикатор Билла Вильямса: разница средних по медианной цене за 5 и 34 бара. '
            + 'Переход через ноль — смена импульса, цвет столбика — усиление или ослабление движения',
      },
      {
        id: 'cvd', name: 'Кумулятивная дельта (CVD)',
        hint: 'Накопленная разница покупок и продаж по рынку: растёт — забирают по аску, падает — льют в бид',
      },
      { id: 'volume', name: 'Объём', hint: 'Объём по свечам — показывает торговую активность' },
    ],
  },
];

export function openIndicatorsModal() {
  const current = { ...(settings.get('sx_indicators', {}) || {}) };
  const list = el('div', { class: 'ind-list' });

  const render = (query = '') => {
    clear(list);
    const q = query.trim().toLowerCase();
    for (const group of GROUPS) {
      const items = group.items.filter((i) => !q || i.name.toLowerCase().includes(q));
      if (!items.length) continue;
      list.append(el('div', { class: 'ind-group-title', text: group.title }));
      for (const item of items) {
        list.append(el('div', { class: 'ind-row' }, [
          toggle(!!current[item.id], (value) => {
            current[item.id] = value;
            settings.set('sx_indicators', { ...current });
          }, { title: item.name, subtitle: item.hint }),
        ]));
      }
    }
    if (!list.children.length) {
      list.append(el('div', { class: 'ind-empty', text: 'Ничего не найдено' }));
    }
  };

  render();

  const body = el('div', { class: 'ind-modal' }, [
    el('input', {
      class: 'ind-search',
      placeholder: 'Поиск индикаторов...',
      oninput: debounce((e) => render(e.target.value), 150),
    }),
    list,
  ]);

  return modal({ title: 'Индикаторы', body, width: 520 });
}
